import React, { useEffect, useRef } from 'react';
import axios from 'axios';

const GeneradorPreguntas = ({ categoria, modo, setPreguntas, setCargando, setPreguntasListas, setErrorGeneracion }) => {
  const preguntasGeneradas = useRef(false);
  const generacionEnProceso = useRef(false);

  useEffect(() => {
    const generarLotePreguntas = async () => {
      const prompt = `Eres un experto en videojuegos de Nintendo y en la franquicia ${categoria}. Genera 10 preguntas de opción múltiple sobre ${categoria} con dificultad básica e intermedia. 
      Las preguntas deben ser precisas, basadas en hechos reales del juego, y tener una única respuesta correcta y clara.
      Asegúrate de que:
      1. Todas las preguntas sean sobre ${categoria} específicamente.
      2. Cada pregunta tenga EXACTAMENTE 4 opciones, ni más ni menos.
      3. La respuesta correcta sea inequívocamente correcta y las incorrectas sean plausibles pero claramente incorrectas.
      4. No haya ambigüedades en las preguntas o respuestas.
      5. Las preguntas sean interesantes y desafiantes para fans de ${categoria}.
      6. No uses comillas simples ni dobles en el contenido de las preguntas y respuestas.
      7. Si necesitas usar comillas en el texto, reemplázalas por comillas simples invertidas o simplemente omítelas.
      8. IMPORTANTE: Asegúrate de que todas las opciones estén correctamente formateadas entre corchetes. Verifica que cada array de opciones comience con [ y termine con ].
      9. Genera el output siguiendo ESTRICTAMENTE el siguiente formato JSON: [{"pregunta": "...", "opciones": ["...", "...", "...", "..."], "respuestaCorrecta": "..."}]
      10. Verifica cuidadosamente que el JSON generado sea válido y que todas las opciones estén correctamente entre corchetes antes de finalizar la respuesta.
      11. Verifica que la respuesta correcta de cada pregunta esté dentro de las opciones generadas.
      12. No cometas faltas ortográficas o de puntuación. Verifica que los pronombres interrogativos lleven tilde y que las preguntas empiecen con signo de pregunta según corresponda.`;

      const response = await axios.post(
        'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent',
        {
          contents: [{ parts: [{ text: prompt }] }]
        },
        {
          params: { key: process.env.REACT_APP_GEMINI_API_KEY },
          headers: { 'Content-Type': 'application/json' }
        }
      );

      if (response.data && response.data.candidates && response.data.candidates[0] && response.data.candidates[0].content) {
        let generatedContent = response.data.candidates[0].content.parts[0].text;
        generatedContent = generatedContent.replace(/^```json\n|\n```$/g, '').trim();
        return JSON.parse(generatedContent);
      }
      throw new Error('La respuesta de la API no tiene la estructura esperada');
    };

    const generarPreguntas = async () => {
      if (preguntasGeneradas.current || generacionEnProceso.current) return;
      
      generacionEnProceso.current = true;
      setCargando(true);

      let numLotes;
      switch (modo) {
        case 'Sin fallos':
          numLotes = 3;
          break;
        case 'Contrarreloj':
          numLotes = 6;
          break;
        default: // Modo Clásico
          numLotes = 1;
      }

      let intentos = 0;
      const maxIntentos = 3;
      let lotesGenerados = 0;
      let todasLasPreguntas = [];

      while (intentos < maxIntentos) {
        try {
          while (lotesGenerados < numLotes) {
            console.log(`Generando lote ${lotesGenerados + 1} de ${numLotes}`);
            const lotePreguntas = await generarLotePreguntas();
            todasLasPreguntas = [...todasLasPreguntas, ...lotePreguntas];
            lotesGenerados++;
            intentos = 0; // Reiniciar intentos después de cada lote exitoso
          }

          setPreguntas(todasLasPreguntas);
          setPreguntasListas(true);
          console.log(`Generadas ${todasLasPreguntas.length} preguntas en total`);
          preguntasGeneradas.current = true;
          break; // Salir del bucle si la generación fue exitosa
        } catch (error) {
          console.error(`Error al generar preguntas (intento ${intentos + 1}):`, error);
          intentos++;
          if (intentos >= maxIntentos) {
            console.error('Se alcanzó el número máximo de intentos');
            setPreguntasListas(false);
            setErrorGeneracion(true);
          } else {
            console.log(`Reintentando generación de preguntas (intento ${intentos + 1})...`);
            await new Promise(resolve => setTimeout(resolve, 2000)); // Esperar 2 segundos antes de reintentar
          }
        }
      }

      setCargando(false);
      generacionEnProceso.current = false;
    };

    generarPreguntas();
  }, [categoria, modo, setPreguntas, setCargando, setPreguntasListas, setErrorGeneracion]);

  return null;
};

export default GeneradorPreguntas;
